import { InjectionToken } from '@angular/core';
import { Routes } from '@angular/router';

export const APP_ROUTES = new InjectionToken<Routes>('APP_ROUTES');
export const TENANTS_ROUTES = new InjectionToken<Routes>('TENANTS_ROUTES');
